










































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component({
  components: {},
})
export default class InputComponent extends Vue {
  @Prop({ default: "" }) readonly placeholder!: string;
  @Prop({ default: "text" }) readonly name!: string;
  @Prop() readonly value!: string | number;
  @Prop({ default: "left", validator: (val) => ["left", "center", "right"].includes(val) })
  readonly textAlign!: "";
  @Prop({ default: "label" }) readonly label!: string | number;
  @Prop({ default: "text", validator: (val) => ["email", "text", "password", "phone", "number"].includes(val) })
  readonly type!: string;
  @Prop({ default: false }) readonly inputError!: boolean;
  @Prop({ default: false }) readonly required!: boolean;
  @Prop({ default: false }) readonly disabled!: boolean;
  @Prop({ default: "" }) readonly maxlength!: string;
  @Prop({ default: true }) readonly width!: string;
  @Prop({ default: false }) readonly tooltip!: boolean | Array<any>;
  @Prop() readonly tooltipPosition!: string;
  @Prop({ default: true }) readonly showAlertMessage!: string | boolean;
  @Prop({ default: false }) readonly isNumericInput!: boolean;
  @Prop({ default: "blue", validator: (val) => ["blue", "red", ""].includes(val) })
  readonly textColor!: string;
  @Prop({ default: "off" })
  readonly autocomplete!: string;

  created() {
    this.id = Math.random()
      .toString(36)
      .substring(7);

    this.$emit("create");
    this.Change();

    if (this.type == "number") {
      this.typeInput = "text";
      this.inputmode = "decimal";
    } else {
      this.typeInput = this.type;
    }
  }

  get paddingInput(): string {
    if (this.type == "password") {
      return "inputPassword";
    } else {
      return "";
    }
  }

  get hasAlertMessage(): boolean {
    return !!this.$slots["alertMessage"];
  }

  private id = "";
  private inputNumber = "";
  private inputValue = "";
  private typeInput = "text";
  private inputmode = "";
  private styleInput = "";
  private maskPhone = "##########";
  private LabelFormatEmail = false;
  private isFocus = false;

  @Watch("value", {
    immediate: true,
  })
  valueChanged(newVal: string) {
    this.inputValue = newVal;
  }

  @Watch("inputValue", {})
  inputValueChanged(newVal: string) {
    if (this.type == "number") {
      if (isNaN(Number(newVal))) {
        this.inputValue = newVal;
      }
    }
    if (!newVal) {
      this.styleInput = this.inputError ? "error" : "";
      this.LabelFormatEmail = false;
    }
  }

  @Watch("inputError", {
    immediate: true,
  })
  inputErrorChanged() {
    this.styleInput = this.inputError ? "error" : "";
  }

  public LabelMaxlength(): number | null {
    if (this.maxlength && this.inputValue) {
      const maxlength = Number(this.maxlength);
      const length = maxlength - this.inputValue.toString().length;
      return length;
    } else if (this.maxlength) {
      return Number(this.maxlength);
    }
    return null;
  }

  public showPass(): void {
    if (this.typeInput == "password") {
      this.typeInput = "text";
    } else {
      this.typeInput = "password";
    }
  }

  public CheckMaxlength(): boolean {
    if (this.maxlength && this.inputValue) {
      const maxlength = Number(this.maxlength);
      if (maxlength - this.inputValue.toString().length < 0) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  public Onblur(): void {
    this.CheckFormat();
    if (this.required) {
      if (this.inputValue == "") {
        this.$emit("update:inputError", true);
        this.styleInput = "error";
      }
    }
    if (this.type !== "password") {
      this.typeInput = "text";
    }
    this.isFocus = false;
  }
  public OnClick() {
    if (this.type == "number") {
      this.typeInput = "number";
      if (this.isNumericInput) {
        this.$emit("input", this.inputValue);
      } else {
        this.$emit("input", this.inputValue.ToNumber());
      }
      setTimeout(() => {
        const refInputComponent: any = this.$refs.inputComponent;
        if (this.isFocus == false) {
          refInputComponent.select();
          this.isFocus = true;
        }
      }, 0);
    } else {
      const refInputComponent: any = this.$refs.inputComponent;
      if (this.isFocus == false) {
        refInputComponent.select();
        this.isFocus = true;
      }
    }
  }

  public Change(): void {
    this.CheckFormat();
    const labelMaxlength = this.LabelMaxlength();
    if (labelMaxlength !== null) {
      if (this.maxlength && Number(labelMaxlength) < 0) {
        this.$emit("update:inputError", true);
        this.styleInput = "error";
      } else {
        this.$emit("update:inputError", false);
        this.styleInput = this.inputError ? "error" : "";
      }
    }
    this.$emit("change");
  }

  public CheckFormat(): void {
    if (this.CheckMaxlength()) {
      this.$emit("update:inputError", true);
      this.styleInput = "error";
    } else {
      this.$emit("update:inputError", false);
      this.styleInput = this.inputError ? "error" : "";
    }
  }

  public blurInputPhone(inputNumber: string): void {
    this.maskPhone = inputNumber.length > 9 ? "###-###-####" : "##-###-####";
  }
}
